import slideFiveDark from './slide-five-dark.png';
import slideFiveLight from './slide-five-light.png';
import slideFourDark from './slide-four-dark.png';
import slideFourLight from './slide-four-light.png';
import slideOneDark from './slide-one-dark.png';
import slideOneLight from './slide-one-light.png';
import slideSixDark from './slide-six-dark.png';
import slideSixLight from './slide-six-light.png';
import slideThreeDark from './slide-three-dark.png';
import slideThreeLight from './slide-three-light.png';
import slideTwoDark from './slide-two-dark.png';
import slideTwoLight from './slide-two-light.png';

const optionComobosSlides = {
  'slide-five-dark': slideFiveDark,
  'slide-five-light': slideFiveLight,
  'slide-four-dark': slideFourDark,
  'slide-four-light': slideFourLight,
  'slide-three-dark': slideThreeDark,
  'slide-three-light': slideThreeLight,
  'slide-two-dark': slideTwoDark,
  'slide-two-light': slideTwoLight,
  'slide-one-dark': slideOneDark,
  'slide-one-light': slideOneLight,
  'slide-six-light': slideSixLight,
  'slide-six-dark': slideSixDark,
};

export default optionComobosSlides;
